<template>
    <div :class="holderWidth">
        <a :href="href" class="article-item" :target="target?'_blank':''">
            <div class="article-item-image" :class="pictureHeight">
                <img :src="imgSrc" class="img-cover" />
                <div v-if="isVideo" class="article-item-play abs-center icon">
                    <!-- <svg-icon name="play" /> -->
                     <img :src="require('@/assets/sprite/svg/close.svg?raw')" alt="">
                </div>
            </div>
            <div class="pt-15">
                <div class="mb-10 d-flex color-grey4 text-h4" v-if="section || date">
                    <span class="mr-10" v-html="section"></span>
                    <span v-html="date"></span>
                </div>
                <div class="text-h5 mb-5" v-html="title"></div>
                <div class="color-grey4" v-if="lead" v-html="lead"></div>
                <div class="mt-10 text-t_sm" v-if="link && linkText">
                    <span class="link link--black_border" v-html="linkText"></span>
                </div>
            </div>
        </a>
    </div>
</template>

<style lang="scss">
@import '@/assets/css/vars.scss';
a.article-item {
    display: block;
    text-decoration: none;

    .article-item-image {
        transition: .3s opacity $trFun;
    }

    @include media(max, lg) {
        &:hover {
            .article-item-image {
                opacity: 0.7;
            }
        }

        &:active {
            .article-item-image {
                opacity: 1;
            }
        }
    }
}
.article-item-play {
    z-index: 20;
    width: 80px;
    height: 80px;
}
</style>

<script>
export default {
    name: 'ArticleItem',
    props: { 
        width: String,
        imgSrc: String,
        section: String,
        date: String,
        title: String,
        lead: String,
        isVideo: Boolean,
        imgFade: Boolean,
        link: String,
        linkText: String,
        href: {
            default: '/news_item'
        },
        target:{
            default: false
        }
    },
    computed: {
        holderWidth() {
            if(this.width) {
                switch(this.width) {
                    case 'md':
                        return 'col-lg-6';
                    break;
                    default:
                        return 'col-lg-4';
                    break;
                }
            } else {
                return 'col-lg-4';
            }
        },
        pictureHeight() {
            let className = '';
            if(this.width) {
                switch(this.width) {
                    case 'md':
                        className = 'height-115 height-lg-75';
                    break;
                    default:
                        className = 'height-115';
                    break;
                }
            } else {
                className = 'height-115';
            }
            
            if(this.imgFade) {
                className += ' opacity-15';
            }

            return className;
        }
    },
    mounted() {

    }
}
</script>
